import { gql } from '@apollo/client'

const UPDATE_CAMPAIGN = gql`
  mutation ($campaignId: ID!, $campaign: UpdateCampaignInput!) {
    updateCampaign(campaignId: $campaignId, campaign: $campaign) {
      statusCode
      code
      error
      message
    }
  }
`

export default UPDATE_CAMPAIGN
